const tableTitleGroup = {
  title: 'Grupos',
  placeholder: 'Buscar por grupo',
  Typography: 'Ningún resultado encontrado'
};

export default tableTitleGroup;
